module.exports = __webpack_public_path__ + "media/images/sponsorLogo-92445fb8a61599c83d72ba4045e4e00e.png";